
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic01Off as ObiHydraulic01OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-01-off.js';
 
 
 

 
 export const ObiHydraulic01Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-01-off',
   elementClass: ObiHydraulic01OffElement,
   events: {
     
   }
  });
 
 